import { DeliveryType } from '../enums/DeliveryType';
import { OrderEmailStatus } from '../enums/OrderStatus';
import { Buyer } from './Buyer';
import { CartSummary } from './CartSummary';
import { Shop } from './Shop';

export interface Cart {
  id: string;
  shop_id: string;
  user_id: string;
  reserved_until: string | null;
  server_time: string;
  status: string;
  delivery_method: DeliveryType;
  summary: CartSummary;
  shop: Shop;
  pay_after: boolean;
  pos_id: string | null;
  timeslot: string;
  timeslot_interval: string;
  comment: string;
  delivery_methods: number[];
}

export enum CartStatus {
  Active = 'active',
  Ordered = 'ordered',
  Canceled = 'canceled',
  Expired = 'expired',
  Paid = 'paid',
}

export const cartStatusOptions = [
  { text: 'reservations.statuses.active', val: CartStatus.Active },
  { text: 'reservations.statuses.ordered', val: CartStatus.Ordered },
  { text: 'reservations.statuses.canceled', val: CartStatus.Canceled },
  { text: 'reservations.statuses.expired', val: CartStatus.Expired },
  { text: 'reservations.statuses.paid', val: CartStatus.Paid },
];

export enum HoldingStatus {
  None = 'none',
  Reserved = 'reserved',
  Paid = 'paid',
  Canceled = 'canceled',
  Expired = 'expired',
}

export const holdingStatusOptions = [
  { text: 'reservations.statuses.reserved', val: HoldingStatus.Reserved },
  { text: 'reservations.statuses.canceled', val: HoldingStatus.Canceled },
  { text: 'reservations.statuses.expired', val: HoldingStatus.Expired },
  { text: 'reservations.statuses.paid', val: HoldingStatus.Paid },
];

export interface CartAdmin extends Cart {
  reservation_code: string | null;
  ready_state: string | null;
  has_restaurant_reservation: boolean;
  buyer: Buyer;
  pos_name: string | null;
  inserted: string;
  company_id: string;
  holding_status: HoldingStatus;
  external_email_id?: number | null;
  external_email_status?: OrderEmailStatus | null;
  external_email_sent?: string | null;
}

export interface UserCartReservation extends Cart {
  on_hold: string | null;
  reservation_code: string | null;
  inserted: string;
  has_restaurant_reservation: boolean;
}
